import _ from '../../utils/LodashImports';

const getLabels = (appCtx) => {
  const textDictionary = _.get(appCtx, 'siteConfig.textDictionary', {});
  return {
    callToAction: {
      openModal: _.get(textDictionary, 'SHOP_THE_PROJECT_CALL_TO_ACTION_OPEN_MODAL', ''),
    },
    coachmark: {
      badge: _.get(textDictionary, 'SHOP_THE_PROJECT_COACHMARK_BADGE', ''),
      title: _.get(textDictionary, 'SHOP_THE_PROJECT_COACHMARK_TITLE', ''),
      description: _.get(textDictionary, 'SHOP_THE_PROJECT_COACHMARK_DESCRIPTION', ''),
      button: _.get(textDictionary, 'SHOP_THE_PROJECT_COACHMARK_BUTTON', ''),
    },
    toast: {
      addToCartError: _.get(textDictionary, 'SHOP_THE_PROJECT_TOAST_ADD_TO_CART_ERROR', ''),
      selectProductsWarning: _.get(textDictionary, 'SHOP_THE_PROJECT_TOAST_SELECT_PRODUCTS_WARNING', ''),
    },
    primaryProducts: {
      title: _.get(textDictionary, 'SHOP_THE_PROJECT_PRIMARY_PRODUCTS_TITLE', ''),
      selectAll: _.get(textDictionary, 'SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL', ''),
      selectAllProducts: _.get(textDictionary, 'SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL_PRODUCTS', ''),
      similarProducts: _.get(textDictionary, 'SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SIMILAR_PRODUCTS', ''),
      save: _.get(textDictionary, 'SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SAVE', ''),
      addToCart: _.get(textDictionary, 'SHOP_THE_PROJECT_PRIMARY_PRODUCTS_ADD_TO_CART', ''),
      badge: _.get(textDictionary, 'SHOP_THE_PROJECT_PRIMARY_PRODUCTS_BADGE', ''),
      goBack: _.get(textDictionary, 'SHOP_THE_PROJECT_PRIMARY_PRODUCTS_GO_BACK', ''),
      noProducts: _.get(textDictionary, 'SHOP_THE_PROJECT_PRIMARY_PRODUCTS_NO_PRODUCTS', ''),
      failText1: _.get(textDictionary, 'SHOP_THE_PROJECT_PRIMARY_PRODUCTS_FAIL_TEXT_1', ''),
      failText2: _.get(textDictionary, 'SHOP_THE_PROJECT_PRIMARY_PRODUCTS_FAIL_TEXT_2', ''),
      retry: _.get(textDictionary, 'SHOP_THE_PROJECT_PRIMARY_PRODUCTS_RETRY', ''),
      moreOptions: _.get(textDictionary, 'SHOP_THE_PROJECT_PRIMARY_PRODUCTS_MORE_OPTIONS', ''),
      imageSimilarProduct: _.get(textDictionary, 'SHOP_THE_PROJECT_PRIMARY_PRODUCTS_IMAGE_SIMILAR_PRODUCT', ''),
    },
    secondaryProducts: {
      title: _.get(textDictionary, 'SHOP_THE_PROJECT_SECONDARY_PRODUCTS_TITLE', ''),
      exchange: _.get(textDictionary, 'SHOP_THE_PROJECT_SECONDARY_PRODUCTS_EXCHANGE', ''),
      goBack: _.get(textDictionary, 'SHOP_THE_PROJECT_SECONDARY_PRODUCTS_GO_BACK', ''),
      noProducts: _.get(textDictionary, 'SHOP_THE_PROJECT_SECONDARY_PRODUCTS_NO_PRODUCTS', ''),
      failText1: _.get(textDictionary, 'SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_1', ''),
      failText2: _.get(textDictionary, 'SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_2', ''),
      retry: _.get(textDictionary, 'SHOP_THE_PROJECT_SECONDARY_PRODUCTS_RETRY', ''),
    },
    tooltip: {
      similarProductText: _.get(textDictionary, 'SHOP_THE_PROJECT_TOOLTIP_SIMILAR_PRODUCT_TEXT', ''),
      buttonText: _.get(textDictionary, 'SHOP_THE_PROJECT_TOOLTIP_BUTTON_TEXT', ''),
      productNotLoaded: _.get(textDictionary, 'SHOP_THE_PROJECT_AMBIENT_IMAGE_PRODUCT_NOT_LOADED', ''),
      tryAgainLater: _.get(textDictionary, 'SHOP_THE_PROJECT_AMBIENT_IMAGE_TRY_AGAIN_LATER', ''),
    },
    ambientImage: {
      title: _.get(textDictionary, 'SHOP_THE_PROJECT_AMBIENT_IMAGE_TITLE', ''),
      description: _.get(textDictionary, 'SHOP_THE_PROJECT_AMBIENT_IMAGE_DESCRIPTION', ''),
      skip: _.get(textDictionary, 'SHOP_THE_PROJECT_AMBIENT_IMAGE_SKIP', ''),
    },
  };
};

export default getLabels;
